var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubMenuIndication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 10,
      height: 10,
      margin: "auto 0 auto auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 3178",
    d: "M2.99559 4.50062L0.247545 7.24859C-0.0825334 7.57869 -0.0825334 8.11389 0.247545 8.4439C0.577623 8.77391 1.11278 8.77391 1.44286 8.4439L4.75316 5.1334C4.92723 4.95947 5.00878 4.72845 4.99925 4.50062C5.00878 4.27269 4.92723 4.04174 4.75316 3.86775L1.44286 0.557232C1.27757 0.392223 1.06151 0.309673 0.845445 0.309673C0.628648 0.309673 0.412584 0.392223 0.247545 0.557232C-0.0825334 0.887341 -0.0825334 1.42254 0.247545 1.75256L2.99559 4.50062Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubMenuIndication);
export default __webpack_public_path__ + "static/media/subMenuIndication.e31888e41dde96c36ab6c0b37dfea91b.svg";
export { ForwardRef as ReactComponent };